<script>
export default {
  name: "PrintLocation",
  props: {
    product: { type: Object, required: true },
    location: { type: Object, required: true },
    number: { type: Number, required: true },
    canMutateStore: { type: Boolean, default: false },
    showErrors: { type: Boolean, default: false },
    maxAttachments: { type: Number },
  },
  data() {
    return {
      /**
       * Имя компонента стратегии вычисления стоимости в зависимости от технологии печати
       */
      costStrategies: {
        silkScreen: 'SilkScreen',
        fullColor: 'FullColor',
        embroidery: 'Embroidery',
        bagPrint: 'BagPrint',
      },
      errors: {
        zeroColors: 'Выберите цвета нанесения',
      },
    }
  },
  computed: {
    allowedTechnologies() {
      return this.location.data.allowedTechnologies.map(technology => {
        return this.$store.state.textilePrint.technologies[technology]
      })
    },
    allowedSquares() {
      return this.location.data.allowedSquares[this.location.technology.id].map(squareLabel => {
        return this.$store.state.textilePrint.squares[squareLabel]
      })
    },
    selectedColors() {
      return this.location.colors.filter((color) => color.selected)
    },
    needsSubstrate() {
      if (!this.location.technology.allowsColorPick) {
        return false
      }
      return this.product.color.id !== 'white'
        && this.selectedColors.filter((color) => color.needsSubstrate).length > 0
    },
    totalSelectedColorsNumber() {
      return this.needsSubstrate ? this.selectedColors.length + 1 : this.selectedColors.length
    },
    maxSelectedColorsNumber() {
      if (!this.location.technology.allowsColorPick) {
        return 0
      }
      return this.location.technology.maxColorsNumber
    },
    squareIsCustom() {
      return this.location.square.id === 'custom'
    },
    costStrategy() {
      const technologyId = this.location.technology.id
      return () => import(`./cost-strats/print/${this.costStrategies[technologyId]}`)
    },
    errorsList() {
      const errors = []
      if (this.location.technology.allowsColorPick && this.location.calculations.totalSelectedColorsNumber === 0) {
        errors.push('zeroColors')
      }
      return errors
    },
    hasErrors() {
      return this.errorsList.length > 0
    },
  },
  methods: {
    update(propsToUpdate) {
      if (!this.canMutateStore) return
      this.$emit('update', { propsToUpdate, item: this.location })
      this.$nextTick(() => {
        this.$emit('update', {
          propsToUpdate: {
            needsSubstrate: this.needsSubstrate,
            totalSelectedColorsNumber: this.totalSelectedColorsNumber,
          },
          item: this.location.calculations
        })
      })
    },
    onColorSelectionChange({ index, selected }) {
      let colors = [...this.location.colors]
      colors[index].selected = selected
      this.update({ colors })
    },
    onSquareSelect(square) {
      this.update({ square })
      this.updateSquareDefaultDimensions()
    },
    onSquareWidthInput(w) {
      this.update({ w })
    },
    onSquareHeightInput(h) {
      this.update({ h })
    },
    onTechnologySelect(technology) {
      this.update({ technology })
      this.$nextTick(() => {
        this.update({
          square: this.allowedSquares[0],
        })
        this.updateSquareDefaultDimensions()
      })
    },
    updateSquareDefaultDimensions() {
      if (this.squareIsCustom) {
        const { w, h } = this.location.square.defaults[this.location.data.id] || this.location.square.defaults.default
        this.update({ w, h })
      }
    },
    onFilesUpload(response) {
      this.$emit('update', {
        propsToUpdate: { files: [...this.location.files, ...response.data] },
        item: this.location
      })
    },
    onMetallizedThreadChange(val) {
      this.update({ metallizedThread: val })
    },
    detachFile(fileToDetach) {
      const files = this.location.files.filter((file) => file !== fileToDetach)
      this.$emit('update', {
        propsToUpdate: { files },
        item: this.location
      })
    },
    updateCost(cost) {
      this.update({ cost: Math.ceil(cost) })
    },
    updatePriceMultiplier(val) {
      this.$emit('update', {
        propsToUpdate: {
          totalPrintPriceMultiplier: val,
        },
        item: this.location.calculations
      })
    },
  },
  render() {
    return this.$scopedSlots.default({
      location: this.location,
      showErrors: this.showErrors,
      maxAttachments: this.maxAttachments,

      errors: this.errors,
      errorsList: this.errorsList,
      hasErrors: this.hasErrors,

      allowedTechnologies: this.allowedTechnologies,
      allowedSquares: this.allowedSquares,
      selectedColors: this.selectedColors,
      needsSubstrate: this.needsSubstrate,
      maxSelectedColorsNumber: this.maxSelectedColorsNumber,
      totalSelectedColorsNumber: this.totalSelectedColorsNumber,
      costStrategy: this.costStrategy,

      onTechnologySelect: this.onTechnologySelect,
      onSquareSelect: this.onSquareSelect,
      onColorSelectionChange: this.onColorSelectionChange,
      onSquareWidthInput: this.onSquareWidthInput,
      onSquareHeightInput: this.onSquareHeightInput,
      updateCost: this.updateCost,
      updatePriceMultiplier: this.updatePriceMultiplier,
      onFilesUpload: this.onFilesUpload,
      detachFile: this.detachFile,
      onMetallizedThreadChange: this.onMetallizedThreadChange,
    })
  },
}
</script>